import { render, staticRenderFns } from "./BusinessSolutions.vue?vue&type=template&id=182ec342&scoped=true&"
import script from "./BusinessSolutions.vue?vue&type=script&lang=js&"
export * from "./BusinessSolutions.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSolutions.vue?vue&type=style&index=0&id=182ec342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182ec342",
  null
  
)

export default component.exports